import React from 'react';
import './style.scss';

export const PositionHeader = () => {
  return (
    <>
      <div className="positionHeader">
        <div className="positionHeader_title">案件名</div>
        <div className="positionHeader_tenant">
          賃借人等<span className="positionList_small_text">※1</span>
        </div>
        <div className="positionHeader_division">損益分配日</div>
        <div className="positionHeader_rate">
          <span>事業開始時</span>
          <span>
            為替レート<span className="positionList_small_text">※2</span>
          </span>
        </div>
        <div className="positionHeader_investmentUSD">出資金額($)</div>
        <div className="positionHeader_investmentJPY">出資金額(¥)</div>
        <div className="positionHeader_contractDate">契約締結日</div>
        <div className="positionHeader_purchaseOption">購入選択権設定日</div>
        <div className="positionHeader_leaseEndDate">リース満了日</div>
        <div className="positionHeader_status">ステータス</div>
        <div className="positionHeader_contract">契約関連書類</div>
      </div>
    </>
  );
};
